import { useState, useEffect } from "react";
import { shouldShowConsentBanner, grantConsent, denyConsent } from "@/lib/analytics";
import { Cookie } from "@phosphor-icons/react";

// Bandeau de consentement RGPD : conditionne le chargement de Google Analytics 4.
// Tant que l'utilisateur n'a pas accepté, AUCUN cookie/tracker GA4 n'est chargé.
export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(shouldShowConsentBanner());
  }, []);

  if (!show) return null;

  const accept = () => { grantConsent(); setShow(false); };
  const refuse = () => { denyConsent(); setShow(false); };

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-[120] rounded-xl border border-border bg-surface/95 backdrop-blur-md shadow-2xl p-5 fade-up"
    >
      <div className="flex items-start gap-3 mb-3">
        <div className="w-9 h-9 rounded-lg bg-accent/12 border border-accent/25 flex items-center justify-center shrink-0">
          <Cookie size={18} weight="duotone" className="text-accent" />
        </div>
        <div>
          <h4 className="text-sm font-semibold text-fg mb-1">Nous respectons votre vie privée</h4>
          <p className="text-xs text-muted leading-relaxed">
            interKO utilise des cookies de mesure d'audience (Google Analytics) pour comprendre
            l'usage du site et l'améliorer. Aucun cookie de suivi n'est déposé sans votre accord.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 justify-end">
        <button
          onClick={refuse}
          data-testid="cookie-refuse"
          className="text-xs font-semibold text-muted hover:text-fg px-4 py-2 rounded-md border border-border hover:border-fg/30 transition-colors"
        >
          Refuser
        </button>
        <button
          onClick={accept}
          data-testid="cookie-accept"
          className="text-xs font-semibold bg-accent text-black px-4 py-2 rounded-md hover:brightness-110 transition"
        >
          Accepter
        </button>
      </div>
    </div>
  );
}
